<template>
  <portlet
      :icon="'fal fa-chart-pie portlet-icon'"
      :title="$t('oeeAnalytics.table.title')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20 oee-chart-portlet"
  >
    <template slot="actionsBlock">

      <div class="row oee-controls">

        <div class="col-12">
          <label for="selected-product-number">{{ $t('oeeAnalytics.performance.productNumber') }}</label>
          <select v-model="filters.productNumber" name="" class=form-control
                  id="selected-product-number">
            <option :value="null">All</option>
            <option v-bind:key="productNumber" v-for="productNumber in getUniqueProductNumbers" :value="productNumber">
              {{ productNumber }}
            </option>
          </select>
        </div>
      </div>
    </template>

    <template slot="portletBody">
      <button type="button" v-if="productionRuns && availability && performance && productionRuns.length" class="btn btn-dark "
              data-toggle="modal"
              data-target="#runexport">
        {{ $t('ui.export') }}
      </button>
      <!-- Modal -->
      <div class="modal fade" id="runexport" tabindex="-1" role="dialog" aria-labelledby="runexport" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{ $t('ui.customKeys') }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="custom-control custom-checkbox" v-for="(key, index) in exportKeys.additionalDataKeys"
                   :key="'customfilter-'+index+ key">
                <input v-model="selectedExportKeys"
                       :value="key"
                       type="checkbox"
                       :id="'customfilter-'+index+ key"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'customfilter-'+index+ key">
                  <span>{{ key }}</span>
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="selectedExportKeys=[]">
                {{ $t('ui.cancel') }}
              </button>
              <button type="button" class="btn btn-primary" @click="csvExport()" data-dismiss="modal">{{
                  $t('ui.export')
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ve-table
          v-if="productionRuns !== null"
          :max-height="400"
          height="400"
          width="100"
          :ref="'productionRunTable'"
          :fixed-header="true"
          :border-y="true"
          :expand-option="null"
          row-key-field-name="rowKey"
          :columns="getColumns"

          :scroll-width="'100vw'"
          :cellSelectionOption="cellSelectionOption"
          :row-style-option="rowStyleOption"
          :table-data="getRowsSorted"/>
      <ComponentLoadSpinnerV2 v-else :loading="true"/>
    </template>

  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import ComponentLoadSpinnerV2 from "@/components/general/ComponentLoadSpinnerV2";
import timeCalc from "@/mixins/timeCalc";

const timeUtils = require('mout/time');
import {sortChange} from "@/mixins/vueEasyTable/sortChange";

export default {
  name: "ProductionRunsTable",
  components: {
    ComponentLoadSpinnerV2
  },
  props:['updateDataTrigger'],
  mixins: [sortChange, timeCalc],
  data() {
    return {
      selectedExportKeys: [],
      productionRuns: null,
      performance: null,
      bdr: null,
      availability: null,
      quality: null,
      filters: {
        productNumber: null
      },
      cellSelectionOption: {
        enable: false,
      },
      virtualScrollOption: {
        enable: true,
      },
      rowStyleOption: {
        stripe: true,
        clickHighlight: true,
        hoverHighlight: true,
      }
    }
  },
  computed: {
    ...mapGetters('company', ['getBdrTimeFrame', 'getProductNumberKey', 'getNpcKey', 'getAvailabilityUnit', 'getNpcUnit', 'getPerformanceUnit', 'getBdrUnit', 'getOeeConfig']),
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getDateRange', 'getQueryFilters', 'getData']),
    ...mapGetters('workflows', ['getWorkflowName']),

    getUniqueProductNumbers() {
        return _.map(_.uniqBy(this.productionRuns, productionRun => {
          return productionRun.additionalData[this.getProductNumberKey];
        }), uniqueProductNumberRun => {
          return uniqueProductNumberRun.additionalData[this.getProductNumberKey]
        });
    },
    getRowsSorted() {
      return _.orderBy(this.getRowsFiltered, this.getSortKeys, this.getSortOrder);
    },
    getRowsFiltered() {
      return _.filter(this.getRows, row => {
        if (!this.filters.productNumber || row.productNumber === this.filters.productNumber) {
          return true;
        } else {
          return false;
        }
      });
    },
    getRows() {
      return _.map(this.productionRuns, productionRun => {

        // Get and calculate availability
        const {
          bdrData,
          oee,
          availability,
          performance,
          producedPerUnit,
          availabilityTime,
          shouldProduceInUnit,
          produced,
          quality
        } = this.calculateOeeData(productionRun)
        return {
          activity: productionRun.activity,
          productionRunId: productionRun.productionRunId,
          jobId: productionRun.jobId,
          uid: productionRun.uid,
          productNumber: productionRun.additionalData[this.getProductNumberKey],
          productionStart: {
            sortValue: productionRun.productionStart ? moment(productionRun.productionStart).unix() : 0,
            parsedValue: productionRun.productionStart ? moment(productionRun.productionStart) : null,
            exportValue: productionRun.productionStart ? moment(productionRun.productionStart) : null,
          },
          productionEnd: {
            sortValue: productionRun.productionEnd ? moment(productionRun.productionEnd).unix() : 0,
            parsedValue: productionRun.productionEnd ? moment(productionRun.productionEnd) : null,
            exportValue: productionRun.productionEnd ? moment(productionRun.productionEnd) : null,
          },
          finishedDate: {
            sortValue: productionRun['finishedDate'] ? moment(productionRun['productionEnd']).unix() : 0,
            parsedValue: productionRun['finishedDate'] ? moment(productionRun['productionEnd']) : null,
            exportValue: productionRun['finishedDate'] ? moment(productionRun['finishedDate']) : null,
          },
          npc: productionRun.additionalData[this.getNpcKey] ? _.round(productionRun.additionalData[this.getNpcKey] * timeUtils.convert(1, this.getNpcUnit, 'ms'), 2) : '',
          defects: productionRun.defects,
          bdr: {
            sortValue: bdrData ? bdrData.bdr : 0,
            parsedValue: bdrData ? bdrData.bdr : null
          },
          availability: {
            sortValue: availability ? availability : 0,
            parsedValue: {
              availability: _.round(availability * 100, 0),
              availabilityTime
            }
          },
          performance: {
            sortValue: performance ? performance : 0,
            parsedValue: {
              performance: isNaN(performance) || !isFinite(performance) ? 0 : _.round(performance * 100),
              producedPerUnit: producedPerUnit ? producedPerUnit : 0
            }
          },
          quality: {
            sortValue: 100,
            parsedValue: 100
          },
          oee: {
            sortValue: oee ? oee : 0,
            parsedValue: oee
          },
          shouldProduce: {
            sortValue: shouldProduceInUnit ? shouldProduceInUnit : 0,
            parsedValue: shouldProduceInUnit
          },
          norm: parseFloat(productionRun.additionalData.norm),
          target: parseInt(productionRun.additionalData.target),
          amountProduced: {
            sortValue: produced ? produced : 0,
            parsedValue: produced
          },
          amountPlanned: parseInt(productionRun.additionalData.amount)
        }
      });
    },
    getColumns() {
      return [
        {
          field: "uid",
          key: 'c1',
          title: this.$t('oeeAnalytics.table.columns.jobNumber'),
          align: "right",
          fixed: 'left',
          width: "100px",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            const url = `/start-stop/${row.jobId}`;
            return (
                <a href={url} target="_blank">
                  {row.uid}
                </a>
            );
          }
        },
        {
          field: "productNumber",
          key: "2",
          title: this.$t('oeeAnalytics.table.columns.productNumber'),
          align: "right",
          width: "175px",
          fixed: 'left',
        },
        {
          field: "productionStart.sortValue",
          key: "3",
          title: this.$t('oeeAnalytics.table.columns.productionStart'),
          align: "right",
          width: "125px",
          sortBy: 'asc',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            if (!row.productionStart.parsedValue) {
              return '';
            } else {
              return row.productionStart.parsedValue.format('DD-MM-YYYY HH:mm ');
            }
          }
        },
        {
          field: "productionEnd.sortValue",
          key: "4",
          title: this.$t('oeeAnalytics.table.columns.productionEnd'),
          align: "right",
          width: "125px",
          sortBy: '',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            if (!row.productionEnd.parsedValue) {
              return '';
            } else {
              return row.productionEnd.parsedValue.format('DD-MM-YYYY HH:mm ');
            }
          }
        },
        {
          field: "finishedDate.sortValue",
          key: "5",
          width: "120px",
          title: this.$t('oeeAnalytics.table.columns.finishedDate'),
          align: "right",
          sortBy: "",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            if (!row.finishedDate.parsedValue) {
              return '';
            } else {
              return row.finishedDate.parsedValue.format('DD-MM-YYYY HH:mm');
            }
          }
        },
        {
          field: "npc",
          key: "6",
          title: this.$t('oeeAnalytics.table.columns.npc'),
          width: "75px",
          align: "right",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }
            if (!row.npc) {
              return ' ';
            } else {
              if (row.npc.parsedValue !== null) {
                return (<div>{row.npc}/{this.$t('oeeAnalytics.table.columns.' + this.getNpcUnit)}</div>)

              } else {
                return '';
              }
            }
          }
        },
        {
          field: "bdr",
          key: "7",
          title: this.$t('oeeAnalytics.table.columns.bdr'),
          align: "right",
          width: "75px",
          renderHeaderCell: ({column}, h) => {
            return (<div data-toggle="tooltip" style="cursor:pointer" data-placement="top"
                         title={this.$t('oeeAnalytics.table.columns.bdrTooltip', {minutes: this.getBdrTimeFrame})}>{this.$t('oeeAnalytics.table.columns.bdr')}</div>)
          },
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }
            if (!this.bdr) {
              return <i class="fas fa-spinner fa-spin"></i>;
            } else {
              if (row.bdr.parsedValue !== null) {
                return (
                    <div>{Math.floor(row.bdr.parsedValue * timeUtils.convert(1, this.getBdrUnit, 'm'))}/{this.$t('oeeAnalytics.table.columns.' + this.getBdrUnit)}</div>)
              } else if (row.productionStart.parsedValue && row.productionStart.parsedValue.isSameOrBefore(moment('2021-12-21', 'YYYY-MM-DD'), 'date')) {
                return (<i data-toggle="tooltip" data-placement="top"
                           title={this.$t('oeeAnalytics.table.columns.tooOldForBdr')} class="fas fa-info-circle"/>)
              } else {
                return '';
              }
            }
          }
        },
        {
          field: "availability.sortValue",
          key: "8",
          title: this.$t('oeeAnalytics.table.columns.availability'),
          align: "right",
          width: "150px",
          sortBy: '',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }
            if (!this.availability) {
              return <i class="fas fa-spinner fa-spin"></i>;
            } else {
              if (row.availability.parsedValue.availability !== null) {
                return (
                    <div class="availability-grid">
                      <div>
                        {row.availability.parsedValue.availability}%
                      </div>
                      <div>
                        {row.availability.parsedValue.availabilityTime} {this.$t('oeeAnalytics.table.columns.' + this.getAvailabilityUnit)}
                      </div>
                    </div>)
              } else {
                return '';
              }
            }
          }
        },
        {
          field: "performance.sortValue",
          key: "9",
          width: '150px',
          title: this.$t('oeeAnalytics.table.columns.performance'),
          align: "right",
          sortBy: '',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }
            if (!this.performance) {
              return <i class="fas fa-spinner fa-spin"></i>;
            } else {
              if (row.performance.parsedValue.performance !== null) {
                return (
                    <div class="performance-grid">
                      <div>
                        {row.performance.parsedValue.performance}%
                      </div>
                      <div>
                        <span>{row.performance.parsedValue.producedPerUnit}/{this.$t('oeeAnalytics.table.columns.' + this.getPerformanceUnit)}</span>
                      </div>
                    </div>)
              } else {
                return 0;
              }
            }
          }
        },
        {
          field: "defects",
          key: "10",
          title: this.$t('oeeAnalytics.table.columns.quality'),
          align: "right",
          width: "100px",
          sortBy: '',
          // renderHeaderCell: ({column}, h) => {
          //   return ()
          // },
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }

            let defects = row.defects
            if (!this.productionRuns) {
              return <i class="fas fa-spinner fa-spin"></i>;
            } else {
              if (defects === null) {
                return (
                    <div data-toggle="tooltip" style="cursor:pointer" data-placement="top"
                         title={this.$t('oeeAnalytics.table.columns.defectsTooltip')}>100% *</div>)
              }

              let quality = defects == 0 ? 1 : 1 - (defects / (defects + row.amountProduced.parsedValue))

              return _.round(quality * 100, 0) + '%';
            }
          }
        },
        {
          field: "oee.sortValue",
          key: "11",
          title: this.$t('oeeAnalytics.table.columns.oee'),
          align: "right",
          width: "100px",
          sortBy: '',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }
            if (!this.availability || !this.performance) {
              return <i class="fas fa-spinner fa-spin"></i>;
            } else {
              if (row.oee.parsedValue !== null) {
                return row.oee.parsedValue + '%';
              } else {
                return '';
              }
            }
          }
        },
        {
          field: "amountProduced.sortValue",
          key: "12",
          title: this.$t('oeeAnalytics.table.columns.amountProduced'),
          align: "right",
          width: "110px",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            }
            if (!this.performance) {
              return <i class="fas fa-spinner fa-spin"></i>;
            } else {
              if (row.amountProduced.parsedValue) {
                return row.amountProduced.parsedValue
              } else {
                return 0;
              }
            }
          }
        },
        {
          field: "amountPlanned",
          key: "13",
          width: "110px",
          title: this.$t('oeeAnalytics.table.columns.amountPlanned'),
          align: "right",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            let renderEmpty = this.renderEmptyByActivity(row.activity)
            if (renderEmpty) {
              return renderEmpty
            } else {
              return row.amountPlanned
            }
          }
        }

      ]
    },
    exportKeys() {

      const standardKeys = ['productionRunId', 'jobId', 'workflowId', 'productionStart', 'productionEnd', 'finishedDate', 'activity', 'amountProduced']
      let additionalDataKeys = !this.productionRuns || !this.productionRuns.length ? [] : _.filter(Object.keys(this.productionRuns[0].additionalData),
          item => !_.includes(['insertTimestamp', 'workflowList', 'jobId', 'updated_at', 'allowedWorkflowIds','finishedBy', 'downTimeIds', 'reasonTreeRequired', 'npcMeta', 'addedPlannedTime', 'amount', 'amountProduced'], item))
      return {
        standardKeys,
        additionalDataKeys
      }
    },
    formattedExportData() {
      let {standardKeys} = this.exportKeys
      const productionRuns = this.productionRuns
      let data = []
      for (let i = 0; i < productionRuns.length; i++) {
        let tempRun = {}
        // Handle standard keys
        for (let k = 0; k < standardKeys.length; k++) {
          let key = standardKeys[k]
          let value = this.parseExportValue(key, productionRuns[i][key])
          tempRun[key] = value
        }
        let {
          bdrData,
          oee,
          availability,
          performance,
          quality,
          producedPerUnit,
          availabilityTime,
          shouldProduceInUnit,
          produced
        } = this.calculateOeeData(productionRuns[i])
        let renderEmpty = this.renderEmptyByActivity(tempRun['activity'])
        tempRun = {
          ...tempRun,
          amount: renderEmpty ? 0 : this.parseExportValue('amount', productionRuns[i]['additionalData']['amount']),
          amountProduced: renderEmpty ? 0 : this.parseExportValue('amountProduced', productionRuns[i]['amountProduced']),
          oee: renderEmpty ? 0 : oee, //_.round(oee * 100, 2),
          availability: renderEmpty ? 0 : _.round(availability * 100, 0),
          performance: renderEmpty ? 0 : _.round(performance * 100, 0),
          producedPerUnit: producedPerUnit ? producedPerUnit : 0,
          producedUnit:this.$t('oeeAnalytics.table.columns.' + this.getPerformanceUnit),
          quality: renderEmpty ? 0 : _.round(quality * 100, 0),
        }
        // handle custom keys selected by user

        for (let k = 0; k < this.selectedExportKeys.length; k++) {
          let key = this.selectedExportKeys[k]
          let value = this.parseExportValue(key, productionRuns[i].additionalData[key])

          tempRun[key] = value
        }
        let runTimeInMs = moment(productionRuns[i]['productionEnd']).diff(moment(productionRuns[i]['productionStart']))
        tempRun.runTimeInMs = runTimeInMs
        tempRun.finishedDate= tempRun.finishedDate ? tempRun.finishedDate : 'running'
        data.push(tempRun)
      }

      return data
    }
  },
  methods: {
    calculateOeeData(productionRun) {
      const availabilityData = _.find(this.availability, availabilityData => {
        return availabilityData.productionRunId === productionRun.productionRunId
      });

      const availability = availabilityData ? availabilityData.availability : null;
      const availabilityTime = availability ? _.round(availabilityData.possibleProductionTime / timeUtils.convert(1, this.getAvailabilityUnit, 'ms'), 2) : 0;

      // Get and calculate performance

      const performanceData = _.find(this.performance, {'productionRunId': productionRun.productionRunId});
      let performance = null;
      let producedPerUnit = null;
      let produced = null;
      let shouldProduceInUnit = null;
      if (performanceData) {
        produced = performanceData.realOutput;
        performance = performanceData.performance;
        producedPerUnit = _.round(produced / timeUtils.convert(availabilityData.productionTime, 'ms', this.getPerformanceUnit), 0);
      }
      let defects = productionRun.defects
      let quality
      if (defects === null || defects == 0) {
        quality = 1
      } else {
        quality = 1 - (productionRun.defects / (productionRun.amountProduced + productionRun.defects))
      }


      // Calculate oee
      let oee = null;
      if (performance !== null && availability !== null) {
        oee = _.round((availability * performance * quality) * 100, 0)
      } else {
        oee = 0;
      }

      // Get bdr
      const bdrData = _.find(this.bdr, bdrRecord => {
        return bdrRecord.productNumber === productionRun.additionalData[this.getProductNumberKey] && bdrRecord.workflowId === productionRun.workflowId
      });

      return {
        performance,
        quality,
        oee,
        availability,
        bdrData,
        shouldProduceInUnit,
        producedPerUnit,
        availabilityTime,
        produced
      }
    },
    parseExportValue(key, value) {
      if (key == 'workflowId') {
        return this.getWorkflowName(value)
      } else if (_.includes(['amount', 'amountProduced', 'defects'], key)) {
        return isNaN(parseFloat(value)) ? 0 : parseFloat(value)
      } else if (key === 'npc') {
        return value ? _.round(value * timeUtils.convert(1, this.getNpcUnit, 'ms'), 2) : ''
      } else if (key == 'target' || key == 'downTimeTotal' || key == 'downTimeTotalPlanned') {
        return this.formattedColonTime(value)
      }
      return value
    },
    csvExport() {
      let arrData = this.formattedExportData
      let title = `ProductionRuns-${moment(this.getDateRange.fromDate).format('DD-MM-YYYY')}-${moment(this.getDateRange.toDate).format('DD-MM-YYYY')}`
        this.exportExcel(arrData,title)

    },
    renderEmptyByActivity(activity) {
      let filter = this.getOeeConfig.activitiesThatActLikeUnscheduledDownTime
      if (filter && filter.includes(activity)) {
        return (
            <div class="excluded">
              -
            </div>)
      } else {
        return null
      }
    },
    async getPerformance() {
      let query = {
        fromDate: this.getDateRange.fromDate.toISOString(),
        toDate: this.getDateRange.toDate.toISOString(),
        workflowId: this.getWorkflowId,
        unit: this.getUnit,
        productNumberKey: this.getProductNumberKey,
        npcKey: this.getNpcKey,
        runView: true
      }
      let performance = await this.$FUNCTIONS.OeeAnalytics("getPerformancePerRun", query).catch(e => {
        console.error(e);
      })
      this.performance = performance.data

      this.$store.commit('oeeAnalytics/setData', {type: 'performance', data: performance.data})

    },
    async getProductionRuns() {
      this.$store.commit('oeeAnalytics/setData', {type: 'productionRuns', data: null})
      let query = {
        fromDate: moment(this.getDateRange.fromDate).startOf('date').toISOString(),
        toDate: this.getDateRange.toDate.toISOString(),
        workflowId: this.getWorkflowId
      }
      let productionRuns = await this.$FUNCTIONS.OeeAnalytics("getProductionRuns", query).catch(e => {
        console.error(e);
      })
      this.productionRuns = _.orderBy(productionRuns.data, run => {
        return moment(run.productionStart)
      }, ['desc'])
      this.$store.commit('oeeAnalytics/setData', {type: 'productionRuns', data: this.productionRuns})

    },
    async getBdr() {
      const response = await this.$FUNCTIONS.OeeAnalytics("getBdr", {
        bdrTimeFrameInMinutes: this.getBdrTimeFrame,
        npcKey: this.getNpcKey,
        productNumberKey: this.getProductNumberKey, ...this.getQueryFilters
      });
      this.bdr = response.data;
      this.$store.commit('oeeAnalytics/setData', {type: 'bdr', data: this.bdr})
    },
    async getAvailability() {
      const response = await this.$FUNCTIONS.OeeAnalytics("getAvailabilityPerRun", this.getQueryFilters);
      this.availability = response.data;
    },
    async getQuality() {
      // let query = {
      //   fromDate: this.getDateRange.fromDate.toISOString(),
      //   toDate: this.getDateRange.toDate.toISOString(),
      //   workflowId: this.getWorkflowId,
      //   unit: this.getUnit
      // }
      // let quality = await this.$FUNCTIONS.OeeAnalytics("getQualityPerRun", query).catch(e => {
      //   console.error(e);
      // })
      // this.quality = quality.data;
    },
    updateData() {
      this.productionRuns = null;
      this.performance = null;
      this.bdr = null;
      this.availability = null;
      this.quality = null
      this.getBdr();
      this.getAvailability();
      this.getPerformance();
      this.getProductionRuns();
      this.getQuality()
    }
  },
  watch: {
    'updateDataTrigger': {
      deep: true,
      handler() {
        this.updateData();
      }
    },
    'getWorkflowId': {
      deep: false,
      handler() {
        // this.updateData();
      }
    }
  },
  created() {
    $("body").tooltip({selector: '[data-toggle=tooltip]'});
    if (this.getDateRange.toDate && this.getDateRange.fromDate) {
      // this.updateData();
    }
  }
}
</script>

<style lang="scss" scoped>
$cerBlue: #2A52BE;
$blackCoral:#4F575E;

.availability-grid, .performance-grid {
  display: grid;
  grid-template-columns: 0.75fr 1.25fr;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}

.inline-column-div {
  width: fit-content;
  display: inline-block;
}

::v-deep  .btn-dark, ::v-deep  .btn-dark:hover, ::v-deep  .btn-dark-active {
  background: $blackCoral;
  border: 0;

}
</style>